import { cloneDeep } from 'lodash';

import ContactUs from '../actions/contactUs';
import {LOGOUT_USER} from "./routeReducers/auth";
import {logout} from "../actions/sagAuth";

const INIT = 'layout/INIT';
const SET_ALERT = 'layout/SET_ALERT';
const SET_FIELDS = 'layout/SET_FIELDS';
const SET_SENDING_MSG = 'layout/SET_SENDING_MSG';

const defaultState = {
  alertMessage: null,
  alertType: null,
  contactFields: {},
  isSendingMsg: false,
};

const setFields = fields => ({ type: SET_FIELDS, fields });

const setSendingMsg = bool => ({ type: SET_SENDING_MSG, bool });

export const setLogoutUser = () => ({type: LOGOUT_USER})


const setAlert = (alertMessage, alertType) => ({
  type: SET_ALERT,
  alertMessage,
  alertType,
});

const changeFields = (fieldName, fieldVal) => (dispatch, getState) => {
  const { contactFields } = getState().layout;

  const clonedFields = cloneDeep(contactFields);

  clonedFields[fieldName] = fieldVal;

  dispatch(setFields(clonedFields));
};

const submitContactUs = e => async (dispatch, getState) => {
  e.preventDefault();

  const { contactFields } = getState().layout;

  const { name, email, message, number } = contactFields;

  if (!name) {
    return dispatch(setAlert('Name field is required', 'danger'));
  }

  if (!email) {
    return dispatch(setAlert('Email field is required', 'danger'));
  }

  if (!number) {
    return dispatch(setAlert('Phone number field is required', 'danger'));
  }

  if (!message) {
    return dispatch(setAlert('Message field is required', 'danger'));
  }

  try {
    dispatch(setSendingMsg(true));
    const response = await ContactUs(name, email, message, number);

    dispatch(setSendingMsg(false));
    dispatch(setAlert('Message sent successfully', 'success'));
  } catch (err) {
    console.error(err);
    dispatch(setSendingMsg(false));
    dispatch(setAlert('Something went wrong. Please try again', 'danger'));
  }
};



export const ACTIONS = {
  init: () => ({ type: INIT }),
  setAlert,
  changeFields,
  submitContactUs,
};

const optToState = () => ({
  contactFields: {
    name: '',
    email: '',
    message: '',
    number: '',
  },
});

function layout(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state, optToState());
    case SET_ALERT:
      return Object.assign({}, state, {
        alertMessage: action.alertMessage,
        alertType: action.alertType,
      });
    case SET_FIELDS:
      return Object.assign({}, state, {
        contactFields: action.fields,
      });
    case SET_SENDING_MSG:
      return Object.assign({}, state, {
        isSendingMsg: action.bool,
      });
    default:
      return Object.assign({}, state);
  }
}

export default layout;



// WEBPACK FOOTER //
// ./src/reducers/layout.js